import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Subscription plan component
 *
 * @param {Object} props
 */
const SubscriptionPlan = ({
                              monthPrice,
                              yearPrice,
                              url,
                              monthPriceOffline,
                              yearPriceOffline,
                              urlOffline,
                              monthPriceOfflineMikveh,
                              yearPriceOfflineMikveh,
                              urlOfflineMikveh,
                              features,
                              turnOnOfflineLabel,
                              turnOnMikvehLabel,
                              buttonLabel,
                              offlineCheckboxId,
                              mikvehCheckboxId
                          }) => {
    const [mode, setMode] = useState('online'); // online, offline, offline_mikveh

    let currentMonthPrice = monthPrice;
    let currentYearPrice = yearPrice;
    let currentUrl = url;

    if (mode === 'offline_mikveh') {
        currentMonthPrice = monthPriceOfflineMikveh
        currentYearPrice = yearPriceOfflineMikveh
        currentUrl = urlOfflineMikveh
    } else if (mode === 'offline') {
        currentMonthPrice = monthPriceOffline
        currentYearPrice = yearPriceOffline
        currentUrl = urlOffline
    }

    const handleChangeOffline = (event) => {
        if (event.target.checked) {
            setMode('offline')
        } else {
            setMode('online')
        }
    };

    const handleChangeMikveh = (event) => {
        if (event.target.checked) {
            setMode('offline_mikveh')
        } else {
            setMode('offline')
        }
    };

    const offlineCheckboxElement = (
        <span className="promo-card-features__item -left">
            <span className="kabbalah-checkbox">
                <input id={offlineCheckboxId} type="checkbox" onChange={handleChangeOffline}/>
                <label htmlFor={offlineCheckboxId}>{turnOnOfflineLabel}</label>
            </span>
        </span>
    );

    const mikvehCheckboxElement = (
        <span className="promo-card-features__item -left">
            <span className="kabbalah-checkbox">
                <input id={mikvehCheckboxId} type="checkbox" disabled={mode === 'online'} onChange={handleChangeMikveh}/>
                <label htmlFor={mikvehCheckboxId}>{turnOnMikvehLabel}</label>
            </span>
        </span>
    );

    return (
        <div className="promo-card-info subscription-plan">
            <div className="promo-card-features">
                {features.map((feature, index) => <span key={index} className="promo-card-features__item">{feature}</span>)}
                {offlineCheckboxElement}
                {mikvehCheckboxElement}
            </div>
            <div className="promo-card-price">
                <span className="promo-card-price__month">{currentMonthPrice}</span>
                <span className="promo-card-price__year">{currentYearPrice}</span>
            </div>
            <div className="promo-card-action">
                <a href={currentUrl} className="promo-card-action__link custom-btn custom-btn--red">
                    <span className="custom-btn__title">{buttonLabel}</span>
                </a>
            </div>
        </div>
    );
};

SubscriptionPlan.displayName = 'SubscriptionPlan';

SubscriptionPlan.propTypes = {
    monthPrice: PropTypes.string.isRequired,
    yearPrice: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,

    monthPriceOffline: PropTypes.string.isRequired,
    yearPriceOffline: PropTypes.string.isRequired,
    urlOffline: PropTypes.string.isRequired,

    monthPriceOfflineMikveh: PropTypes.string.isRequired,
    yearPriceOfflineMikveh: PropTypes.string.isRequired,
    urlOfflineMikveh: PropTypes.string.isRequired,

    features: PropTypes.arrayOf(PropTypes.string).isRequired,

    turnOnOfflineLabel: PropTypes.string.isRequired,
    turnOnMikvehLabel: PropTypes.string.isRequired,
    offlineCheckboxId: PropTypes.string.isRequired,
    mikvehCheckboxId: PropTypes.string.isRequired,

    buttonLabel: PropTypes.string.isRequired
};

export default SubscriptionPlan;
